import { useState } from "react";
import {
  Row,
  Col,
  Tree,
  Divider,
  Typography,
  Radio,
  Space,
  DatePicker,
} from "antd";
import type { DatePickerProps, RadioGroupProps } from "antd";
import { TreeProps } from "antd/lib/tree";
import { IFacebookCampaign } from "screens/adLibrary/facebookUtils/types";
import styles from "../FlipperDrawer.module.scss";
import RequiredMark from "shared/components/RequiredMark";
import Placeholder from "shared/components/Placeholder";

const Select = ({
  storeName,
  campaigns,
  flipWithAds,
  setFlipWithAds,
  checkedKeys,
  setCheckedKeys,
  setTargetDate,
}: {
  storeName: string;
  campaigns: IFacebookCampaign[];
  flipWithAds: boolean;
  setFlipWithAds: (flipWithAds: boolean) => void;
  checkedKeys: React.Key[];
  setCheckedKeys: (checkedKeys: React.Key[]) => void;
  setTargetDate: (targetDate: string) => void;
}) => {
  const [picker, setPicker] = useState<"month" | "quarter">("quarter");
  const [selectedDate, setSelectedDate] = useState<moment.Moment | null>();
  const onDatePick: DatePickerProps["onChange"] = (date, dateString) => {
    setSelectedDate(date);
    setTargetDate(dateString);
  };
  const onPickerChange: RadioGroupProps["onChange"] = e => {
    setPicker(e.target.value);
    setSelectedDate(null);
    setTargetDate("");
  };

  const treeData = campaigns.map(campaign => {
    return {
      title: campaign.name,
      children:
        campaign?.adsets?.data.map(adset => {
          return { title: adset.name, key: adset.id, selectable: true };
        }) || [],
      key: campaign.id,
      selectable: true,
    };
  });

  return (
    <Row className={styles.container}>
      <Col className={styles.column} span={16}>
        <Typography.Title level={5}>Source Campaigns</Typography.Title>
        <Typography.Text strong>{storeName}</Typography.Text>
        <Tree
          treeData={treeData}
          onCheck={setCheckedKeys as TreeProps["onCheck"]}
          checkedKeys={checkedKeys}
          checkable
          defaultExpandAll
          height={800}
        />
      </Col>
      <Divider className={styles.divider} type="vertical" />
      <Col className={styles.column} span={6}>
        <Typography.Title level={5}>Destination Campaigns</Typography.Title>
        <Typography.Text>Date range</Typography.Text>
        <Radio.Group onChange={onPickerChange} value={picker}>
          <Space direction="vertical">
            <Radio value={"month"}>Monthly</Radio>
            <Radio value={"quarter"}>Quarterly</Radio>
          </Space>
        </Radio.Group>
        <Placeholder />
        <Typography.Text>
          Change to <RequiredMark />
        </Typography.Text>
        <DatePicker
          value={selectedDate}
          onChange={onDatePick}
          picker={picker}
          style={{ width: "60%" }}
        />
        <Placeholder />
        <Typography.Text>Duplicate</Typography.Text>
        <Radio.Group
          onChange={e => setFlipWithAds(e.target.value)}
          value={flipWithAds}
        >
          <Space direction="vertical">
            <Radio value={false}>Campaigns & Ad Sets only</Radio>
            <Radio value={true}>Campaigns, Ad Sets & Ads</Radio>
          </Space>
        </Radio.Group>
      </Col>
    </Row>
  );
};

export default Select;
